import { useState } from 'react';
import { Row, Col, Button, Modal, Alert } from 'react-bootstrap';
import _ from 'lodash'

const currency = window.location.hostname === 'seller.giftr.my' ? 'RM' : 'S$'

const ApplyVariantTemplateModal = ({ onHide, onConfirm, template, hasExistingVariants }) => {
  const [baseCost, setBaseCost] = useState('')

  const base = parseFloat(baseCost) || 0

  const submit = (e) => {
    e.preventDefault();
    e.stopPropagation();
    if (!e.target.reportValidity()) {
      return
    }

    onConfirm(base)
  }

  return (
    <Modal show={true} onHide={onHide} size="lg" style={{zIndex: '10000'}}>
      <Modal.Header>
        <h4 className="mb-0">Apply Variant Template</h4>
      </Modal.Header>
      <form onSubmit={submit}>
        <Modal.Body>
          <Row className="d-grid gap-3 mb-3">
            <Col className="d-grid gap-1">
              <label>Base Item Cost ({currency}) *</label>
              <input className="form-control" type="number" required min="0" step=".01" placeholder="0.00" autoFocus value={baseCost} onChange={(e) => setBaseCost(e.target.value)}/>
            </Col>
          </Row>
          <div className='table-responsive'>
            <table className="table" style={{ fontSize: '0.9em' }}>
              <thead>
                <tr>
                  <th>{template.name}</th>
                  <th width="180">Incremental Price ({currency})</th>
                  <th width="140">Price ({currency})</th>
                </tr>
              </thead>
              <tbody>
                { _.map(template.values, (val, i) => (
                  <tr key={i}>
                    <td>{val.value}</td>
                    <td>+ {parseFloat(val.incremental_price || 0).toFixed(2)}</td>
                    <td><strong>{(base + parseFloat(val.incremental_price || 0)).toFixed(2)}</strong></td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
          { hasExistingVariants &&
            <Alert variant="warning" className="mb-0">
              Applying this template will replace the current options and variants of this product.
            </Alert>
          }
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={onHide}>
            Close
          </Button>
          <Button variant="primary" type="submit">
            Confirm
          </Button>
        </Modal.Footer>
      </form>
    </Modal>
  )
}

export default ApplyVariantTemplateModal
